<template>
  <div>
    <el-card class="box-card boxcard" v-if="dt3.filter((v) => v.ciszp != '否').length!=0">
      <div slot="header" class="clearfix">
        <i class="el-icon-s-operation"></i><b>赠品信息</b>
      </div>

      <el-table :data="dt3.filter((v) => v.ciszp != '否')" border style="width: 100%;" class="tb-edit" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" highlight-current-row>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column label="供应商" prop="cvenname_grive"></el-table-column>
        <el-table-column label="赠品" prop="cgiveawayms"></el-table-column>

      </el-table>
    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <i class="el-icon-picture"></i><b>附件信息</b>
      </div>
      <el-table :data="dt4" border style="width: 100%;" max-height="420" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" highlight-current-row>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column label="附件名称" prop="ctype_file" width="200"></el-table-column>
        <el-table-column label="供应商" prop="cvenname_file" width="200"></el-table-column>
        <el-table-column label="附件信息" prop="curl_file"></el-table-column>
        <el-table-column label="预览" width="80">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="GetHTFileUrl(scope.row)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <i class="el-icon-s-data"></i><b>税率详情</b>
      </div>
      <el-table :data="dt5" border style="width: 100%;" max-height="420" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" highlight-current-row>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column label="供应商" prop="cvenname_grive"></el-table-column>
        <el-table-column label="税码" prop="cmwskz"></el-table-column>
        <el-table-column label="税率名称" prop="ctaxname"></el-table-column>
        <el-table-column label="税率" prop="itaxrate" width="120"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    dt3: { Type: Array },
    dt4: { Type: Array },
    dt5: { Type: Array },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.dt3);
  },
  methods: {
    GetHTFileUrl(row) {
      if (row.curl_file != "" && row.curl_file != undefined) {
        window.open(this.global.BASE_URL + row.curl_file);
      } else {
        this.$message.error("暂无文件！！");
      }
    },
  },
};
</script>
<style scoped>
.inputwidth {
  width: 30%;
}
.inputwidth .el-input__inner {
  border: 0;
}
</style>

